import { DashboardConstants } from "src/redux/actions/constant";
const {
    GET_OTHER_DASHBOARD_DOCUMENT_REQUEST,
    GET_OTHER_DASHBOARD_DOCUMENT_SUCCESS,
    GET_OTHER_DASHBOARD_DOCUMENT_FAILURE,
    GET_OTHER_DASHBOARD_DOCUMENT_LOADER,
    GET_OTHER_DASHBOARD_DOCUMENT_RESET,
} = DashboardConstants;
const intitialstate: any = {
  response: null,
  isGetDocuments: false,
  loading: false,
  totalFacility: [],
  currentPage: -1,
  pageNumber: 0,
};

export const otherDashboardDocumentListReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_OTHER_DASHBOARD_DOCUMENT_SUCCESS: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          isGetDocuments: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: [...state.totalFacility, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          isGetDocuments: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalFacility: action.payload?.data?.content || [],
        };
      }
    }

    case GET_OTHER_DASHBOARD_DOCUMENT_FAILURE:
      return {
        ...state,
        isGetDocuments: false,
        response: action.payload,
        loading: false,
      };

    case GET_OTHER_DASHBOARD_DOCUMENT_LOADER:
      return {
        ...state,
        loading: true,
      };
    case GET_OTHER_DASHBOARD_DOCUMENT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
